import React from 'react';
import Navbar from './Navbar/Navbar';
import Masthead from './Masthead/Masthead';
import About from './About/About';
import Services from './Services/Services';
import JoinUs from './JoinUs/JoinUs';
import Contact from './Contact/Contact';
import Footer from './Footer/Footer'

class App extends React.Component {
    render() {
        return (
            <div id="page-top">
                <Navbar/>
                <Masthead/>
                <About/>
                <Services/>
                <Contact/>
                <JoinUs/>
                <Footer/>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/js/App/App.js